import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function FeaturedWorks() {
  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-[family-name:var(--font-heading)]">
            内容分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">探索冲田杏梨的精彩世界</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-4 text-sm font-semibold text-foreground-900 whitespace-nowrap">
                {cat.name}
              </h3>
              <span className="mt-1 text-xs text-foreground-500">
                {cat.count} 篇内容
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}